import { Toolbar } from 'components/Toolbar';
import type { IUseAccess } from 'hooks/useAccess';
import { Button, Loader } from 'uikit';
import { formatDateToLocale } from 'utils';

import type { FC } from 'react';

import Styles from './catalogTypesWork.module.css';

interface ICatalogTypesWorkToolbar {
    handleCreateTypeWork: () => void;
    updatedDate: Date;
    workTypesDateInProgress: boolean;
    catalogTypesOfWorkRules: IUseAccess['catalogTypesOfWork'];
}

export const CatalogTypesWorkToolbar: FC<ICatalogTypesWorkToolbar> = ({
    handleCreateTypeWork,
    updatedDate,
    workTypesDateInProgress,
    catalogTypesOfWorkRules,
}) => (
    <Toolbar>
        <div className={Styles.ContentToolbar}>
            <Button
                disabled={!catalogTypesOfWorkRules.canCreate}
                label="Создать вид работ"
                onClick={handleCreateTypeWork}
                size="s"
                view="secondary"
            />
            {workTypesDateInProgress ? (
                <div style={{ width: '24px' }}>
                    <Loader />
                </div>
            ) : (
                <span className={Styles.titleTime}>Обновлён: {formatDateToLocale(updatedDate, true)}</span>
            )}
        </div>
    </Toolbar>
);

CatalogTypesWorkToolbar.displayName = 'CatalogTypesWorkToolbar';
